import { render, staticRenderFns } from "./Operatsiya.vue?vue&type=template&id=4eb2bbe8&scoped=true"
import script from "./Operatsiya.vue?vue&type=script&lang=js"
export * from "./Operatsiya.vue?vue&type=script&lang=js"
import style0 from "./Operatsiya.vue?vue&type=style&index=0&id=4eb2bbe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb2bbe8",
  null
  
)

export default component.exports